import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import styles from "./BooleanButtons.module.scss";
import {GRID_VIEW, LIST_VIEW, TIMELINE_VIEW} from "../../constants";
import TimelineIcon from "../../icons/TimelineIcon";
import GroupedByBookingIcon from "../../icons/GroupedByBookingIcon";

const LegacyBooleanButtons = ({ activeStyle, value, onChange, trueLabel, falseLabel, trueProps, falseProps }) => (
  <div className={styles.booleanButton}>
    <button
      type="button"
      onClick={() => onChange(true)}
      style={value === true ? activeStyle : undefined}
      {...trueProps}
    >
      {trueLabel}
    </button>

    <div className={styles.verticalLine}></div>

    <button
      type="button"
      onClick={() => onChange(false)}
      style={value === false ? activeStyle : undefined}
      {...falseProps}
    >
      {falseLabel}
    </button>
  </div>
);

const BookingViewButtons = ({ activeStyle, value, listGroupByView, onChange, onGroupByChange }) => {
  const isGroupedByBooking = value === LIST_VIEW && listGroupByView === "BOOKING";
  const isGroupedByNone = value === LIST_VIEW && (listGroupByView === "NONE" || listGroupByView === "EQUIPMENT");

  return (
    <div className={styles.booleanButton}>
      <button
        data-testid="button-for-booking-grouped-view"
        aria-label="Grouped by booking view"
        type="button"
        onClick={() => onGroupByChange && onGroupByChange("BOOKING")}
        style={isGroupedByBooking ? activeStyle : undefined}
      >
        <GroupedByBookingIcon style={{ width: 45 }} />
      </button>

      <div className={styles.verticalLine}></div>

      <button
        data-testid="button-for-booking-list-view"
        type="button"
        aria-label="List view grouped by none"
        onClick={() => onGroupByChange && onGroupByChange("NONE")}
        style={isGroupedByNone ? activeStyle : undefined}
      >
        <FormatListBulletedIcon style={{ width: 45 }} />
      </button>

      <div className={styles.verticalLine}></div>

      <button
        data-testid="button-for-booking-grid-view"
        type="button"
        onClick={() => onChange(GRID_VIEW)}
        style={value === GRID_VIEW ? activeStyle : undefined}
      >
        <CalendarTodayIcon style={{ width: 45 }} />
      </button>

      <div className={styles.verticalLine}></div>

      <button
        data-testid="button-for-booking-timeline-view"
        type="button"
        aria-label="Timeline view"
        onClick={() => onChange(TIMELINE_VIEW)}
        style={value === TIMELINE_VIEW ? activeStyle : undefined}
      >
        <TimelineIcon style={{ width: 45 }} />
      </button>
    </div>
  );
};

const BooleanButtons = ({
  trueLabel,
  falseLabel,
  trueProps,
  falseProps,
  value,
  onChange,
  variant,
  listGroupByView,
  onGroupByChange,
}) => {
  const activeStyle = {
    backgroundColor: "var(--one-color-interaction-active-brand-4)",
    color: "var(--one-color-interaction-focus-brand-1)",
  };

  if (variant !== "bookingViews") {
    return (
      <LegacyBooleanButtons
        activeStyle={activeStyle}
        value={value}
        onChange={onChange}
        trueLabel={trueLabel}
        falseLabel={falseLabel}
        trueProps={trueProps}
        falseProps={falseProps}
      />
    );
  }

  return (
    <BookingViewButtons
      activeStyle={activeStyle}
      value={value}
      listGroupByView={listGroupByView}
      onChange={onChange}
      onGroupByChange={onGroupByChange}
    />
  );
};

export default BooleanButtons;
